import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class RemoveUser extends React.Component {
    onRemove = () => {
        const { users, onSubmit } = this.props;

        const membersIds = users.map(user => user.id);
        onSubmit({ membersIds });
    };

    render() {
        const { isOpen, closeDialog } = this.props;
        return (
            <Dialog open={isOpen} onClose={closeDialog}>
                <DialogTitle>Remove user</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to remove the selected users?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDialog}>CANCEL</Button>
                    <Button
                        onClick={this.onRemove}
                        variant="contained"
                        color="primary"
                    >
                        REMOVE
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

RemoveUser.propTypes = {
    users: PropTypes.array,
    onSubmit: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    closeDialog: PropTypes.func.isRequired,
};

RemoveUser.defaultProps = {
    users: [],
};

export default RemoveUser;



// WEBPACK FOOTER //
// ./src/components/RemoveUser.js